var map = {
  "./areas/administration/authentication/oauth2/translations": "605973",
  "./areas/administration/authentication/smtp/translations": "547008",
  "./areas/administration/authentication/translations": "801133",
  "./areas/administration/template/serviceModelForm/translations": "400088",
  "./areas/administration/translations": "109246",
  "./areas/assetgroups/translations": "698928",
  "./areas/assets/details/components/asset-configuration/translations": "785843",
  "./areas/assets/monitors/shared-components/translations": "477502",
  "./areas/assets/translations": "400471",
  "./areas/automation/translations": "702701",
  "./areas/cost/translations": "70611",
  "./areas/dashboards/dashboards-grid-store/components/DuplicateDashboardWizard/translations": "159580",
  "./areas/dashboards/dashboards-grid-store/translations": "184762",
  "./areas/dashboards/designer-page/translations": "747491",
  "./areas/dashboards/translations": "331307",
  "./areas/data-sources/components/DataSourceDataConstructor/translations": "901180",
  "./areas/data-sources/components/DataSourceSingleGraphWidget/translations": "456524",
  "./areas/data-sources/translations": "186849",
  "./areas/images/translations": "904786",
  "./areas/incidents/IncidentsGridStore/translations": "132476",
  "./areas/incidents/translations": "951053",
  "./areas/incidents/widgets/IncidentsGridWidget/translations": "730323",
  "./areas/kpi/translations": "815254",
  "./areas/login/translations": "942419",
  "./areas/management/translations": "188865",
  "./areas/master-grid/translations": "562755",
  "./areas/metrics/components/LabelOptionsEditor/translations": "224358",
  "./areas/metrics/components/MetricLegendSelect/translations": "513402",
  "./areas/metrics/components/MetricSelector/translations": "618970",
  "./areas/metrics/components/MetricTooltipSelect/translations": "151530",
  "./areas/metrics/widgets/Compass/translations": "413044",
  "./areas/metrics/widgets/translations": "332745",
  "./areas/monitors/components/monitor-events-grid/translations": "37124",
  "./areas/monitors/event-log-monitor/event-log-monitor-page/translations": "74951",
  "./areas/monitors/service-monitor/service-monitor-page/translations": "162883",
  "./areas/monitors/system-monitor/SystemMonitorPage/translations": "304745",
  "./areas/reports/translations": "436897",
  "./areas/service-boards/chartSettings/translations": "369999",
  "./areas/service-boards/translations": "656129",
  "./areas/services/service-log/translations": "16641",
  "./areas/services/state-override/translations": "367991",
  "./areas/services/translations": "852088",
  "./areas/sla/notes/translations": "542828",
  "./areas/sla/translations": "211258",
  "./areas/views/translations": "386470",
  "./components/operating-period-editor/translations": "203061",
  "./controls/designer-v2/translations": "614110",
  "./controls/designer/features/widgets/datasources/shared/translations": "508921",
  "./controls/designer/features/widgets/textWidget/translations": "176291",
  "./controls/designer/features/widgets/translations": "408635",
  "./controls/designer/translations": "729765",
  "./controls/react/form/formBuilderNew/translations": "787996",
  "./controls/react/translations": "565543",
  "./controls/react/variable-binding/translations": "235142",
  "./controls/stateRenderer/translations": "559236",
  "./controls/translations": "560643",
  "./core/localization/translations": "855192",
  "./framework/time/translations": "49021",
  "./layout/userTags/translations": "255928",
  "./tools/translations": "255898"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 482849;
